import { render } from "./roomdetails.vue?vue&type=template&id=1ea900c6"
import script from "./roomdetails.vue?vue&type=script&lang=js"
export * from "./roomdetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__